import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ActivityTab } from '@/features/deals';

export const Route = createFileRoute('/_app/deals/$dealId/activity')({
  validateSearch: z.object({ actor: z.string().max(64).optional() }),
  component: function Tab() {
    const { dealId } = Route.useParams();
    const { actor } = Route.useSearch();
    const navigate = Route.useNavigate();
    return <ActivityTab dealId={dealId} actor={actor} onActorChange={(next) => void navigate({ search: next ? { actor: next } : {}, replace: true })} />;
  },
});
